import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/** Vrai si l'adresse et la clé publique Supabase sont renseignées. */
export const supabaseConfigured = Boolean(url && anonKey)

// Seule la clé PUBLIQUE (anon) est utilisée ici. Les protections d'accès (RLS)
// dans la base empêchent toute lecture sans être connecté et inscrit dans app_users.
export const supabase = createClient(url || 'http://localhost', anonKey || 'absente', {
  auth: { persistSession: true, autoRefreshToken: true },
})
